import React, { useEffect, useState } from "react";
import {
  Plus,
  Pencil,
  Trash2,
  MapPin,
  Building2,
  LandPlot,
  Home as HomeIcon,
  X,
  Upload,
  ChevronDown,
  Search,
  IndianRupee,
  User,
  Eye,
  Menu,
  Coins,
  ArrowUpRight,
} from "lucide-react";
import { LogoutOutlined } from "@ant-design/icons";
import { Dropdown, message, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../../config/config";
import PortfolioOverview from "../../investor/portfolioOverview/PortfolioOverview";
import ScrollReveal from "../../../common/scrollReveal/ScrollReveal";

const initialProperties = [];

const emptyForm = {
  name: "",
  description: "",
  location: "",
  property_type: "Apartment",
  area_sqft:"",
  property_value_aed: "",
  total_tokens: "",
  price_per_block_aed: "",
  gross_annual_yield_pct: "",
  vesting_days: "",
  images: [],
};


const OwnerHome = () => {
  const [properties, setProperties] = useState(initialProperties);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [form, setForm] = useState(emptyForm);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate()
    const [isProfileModalOpen, setIsProfileModalOpen] =
      useState(false);
  
    const [profile, setProfile] = useState(null);
  
    const [isProfileLoading, setIsProfileLoading] =
      useState(false);
  

  const handleAddImageUrl = () => {
    const url = imageUrl.trim();

    if (!url) return;

    const newImage = {
      id: `${Date.now()}-${Math.random()}`,
      source: "url",
      value: url,
      preview: url,
    };

    setForm((prev) => ({
      ...prev,
      images: [...(prev.images || []), newImage],
    }));

    setImageUrl("");
  };

  const getMyProperties = async () => {
    try {
      const token = localStorage.getItem("rwatoken");

      const response = await axios.get(`${BASE_URL}/owner/me/properties`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setProperties(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.log("Error fetching owner properties:", error);
      setProperties([]);
      if(error?.status === 401){
        localStorage.removeItem("rwatoken");
        localStorage.removeItem("userRole");
        window.location.href = "/";
        navigate("/login", { replace: true });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMyProperties();
  }, []);
  const getToken = () => {
    return localStorage.getItem("rwatoken");
  };

  const openAddModal = () => {
    setForm({ ...emptyForm, images: [] });
    setImageUrl("");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setImageUrl("");
    setForm({ ...emptyForm, images: [] });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.name.trim() ||
      !form.location.trim() ||
      !form.property_type ||
      form.property_value_aed === "" ||
      form.total_tokens === "" 
    ) {
      message.error("Please fill out All the information")
      return;
    }

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("rwatoken");
      const formData = new FormData();

      formData.append("name", form.name.trim());
      formData.append("description", form.description?.trim() || "");
      formData.append("location", form.location.trim());
      formData.append("property_type", form.property_type);
      formData.append("property_value_aed", String(form.property_value_aed));
      formData.append("total_tokens", String(form.total_tokens));
      formData.append("area_sqft", String(form.area_sqft));
      formData.append("zone_name", String(form.zone_name));
      formData.append("registered_agency", String(form.registered_agency));
      formData.append("rera_number", String(form.rera_number));
      formData.append("brn", String(form.brn));
      formData.append("zone_name", String(form.zone_name));

      // formData.append(
      //   "price_per_block_aed",
      //   String(form.price_per_block_aed)
      // );

      if (form.gross_annual_yield_pct !== "") {
        formData.append(
          "gross_annual_yield_pct",
          String(form.gross_annual_yield_pct)
        );
      }

      if (form.vesting_days !== "") {
        formData.append("vesting_days", String(form.vesting_days));
      }

      // Send every selected image using the same `images` field name.
      // Uploaded files are sent as File objects; URL images are sent as strings.
      (form.images || []).forEach((image) => {
        if (image?.source === "upload" && image?.value instanceof File) {
          formData.append("images", image.value);
        } else if (image?.source === "url" && image?.value) {
          formData.append("images", image.value);
        }
      });

      const response = await axios.post(
        `${BASE_URL}/owner/me/properties`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Property created successfully:", response?.data);

      closeModal();
      await getMyProperties();
    } catch (error) {
      console.log("Error adding property:", error);
        const detail = error?.response?.data?.detail;

    let errorMessage = "Something Went Wrong. Please try again.";
    errorMessage =
      detail?.[0]?.msg ||
      detail ||
      "Something Went Wrong. Please try again.";
      message.error(errorMessage)
      if(error?.status === 401){
        localStorage.removeItem("rwatoken");
        localStorage.removeItem("userRole");
        window.location.href = "/";
        navigate("/login", { replace: true });
      }
      
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleImageUpload = (e) => {
  const files = Array.from(e.target.files || []);

  const newImages = files.map((file) => ({
    id: `${Date.now()}-${Math.random()}`,
    source: "upload",
    value: file,
    preview: URL.createObjectURL(file),
  }));

  setForm((prev) => ({
    ...prev,
    images: [...(prev.images || []), ...newImages],
  }));

  e.target.value = "";
};
const handleRemoveImage = (imageId) => {
  setForm((prev) => ({
    ...prev,
    images: prev.images.filter(
      (image) => image.id !== imageId
    ),
  }));
};
  const filteredProperties = properties.filter((property) => {
    const searchValue = search.toLowerCase().trim();

    return (
      String(property?.name || "").toLowerCase().includes(searchValue) ||
      String(property?.location || "").toLowerCase().includes(searchValue) ||
      String(property?.property_type || "").toLowerCase().includes(searchValue)
    );
  });

  const totalValue = properties.reduce(
    (sum, property) => sum + Number(property?.property_value_aed || 0),
    0
  );

  const formatCurrency = (value) => {
    if (!value) return "AED 0";

    return `AED ${Number(value).toLocaleString()}`;
  };
//   const userMenu = {
//   items: [
//     {
//       key: "logout",
//       icon: <LogoutOutlined />,
//       label: "Sign Out",
//       danger: true,
//     },
//   ],
//   onClick: ({ key }) => {
//     console.log("Menu clicked:", key);

//     if (key === "logout") {
//       console.log("Before:", localStorage.getItem("rwatoken"));

//       localStorage.removeItem("rwatoken");
//       localStorage.removeItem("userRole");

//       console.log("After:", localStorage.getItem("rwatoken"));
//       window.location.href = "/";
//       navigate("/login", { replace: true });
//     }
//   },
// };

 const getProfile = async () => {
    try {
      // setIsProfileLoading(true);
      // setIsProfileModalOpen(true);

      const token = getToken();

      const response = await axios.get(
        `${BASE_URL}/owner/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data) {
        setProfile(response.data);
      }
    } catch (error) {
      console.log(
        "Error fetching investor profile:",
        error
      );

      setProfile(null);
    } finally {
      setIsProfileLoading(false);
    }
  };
  useEffect(()=>{
    getProfile()
  },[])
const handleLogout = () => {

      console.log("Before:", localStorage.getItem("rwatoken"));

      localStorage.removeItem("rwatoken");
      localStorage.removeItem("userRole");

      console.log("After:", localStorage.getItem("rwatoken"));
      window.location.href = "/";
      navigate("/login", { replace: true });
  }
 const userMenu = {
    items: [
      {
        key: "profile",
        icon: <User size={14} />,
        label: "Profile",
      },
      {
        type: "divider",
      },
      {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Sign Out",
        danger: true,
      },
    ],

    onClick: ({ key }) => {
      if (key === "profile") {
        getProfile();
        setIsProfileLoading(true);
      setIsProfileModalOpen(true);
      }

      if (key === "logout") {
        handleLogout();
      }
    },
  };
  const ImagePreview = ({
  image,
  index,
  onRemove,
}) => {
  return (
    <div className="group relative aspect-[4/3] overflow-hidden rounded-[7px] border border-[#e5e4da] bg-[#f2f0e7]">

      <img
        src={image.preview}
        alt={`Property ${index + 1}`}
        className="h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]"
      />

      {/* COVER LABEL */}
      {index === 0 && (
        <div className="absolute left-2 top-2 rounded-[4px] bg-[#375c20] px-2 py-1 text-[8px] font-semibold text-white">
          COVER IMAGE
        </div>
      )}

      {/* IMAGE NUMBER */}
      <div className="absolute bottom-2 left-2 rounded-[4px] bg-black/50 px-1.5 py-1 text-[8px] text-white">
        {index + 1}
      </div>

      {/* REMOVE */}
      <button
        type="button"
        onClick={() => onRemove(image.id)}
        className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-white/95 text-[#777] opacity-0 shadow-sm transition group-hover:opacity-100 hover:text-[#a15a50]"
      >
        <X size={12} />
      </button>
    </div>
  );
};

 const propertyCategories = [
  {
    title: "Residential",
    opportunities: "43 opportunities",
    image:
      "https://images.unsplash.com/photo-1510798831971-661eb04b3739?auto=format&fit=crop&w=900&q=85",
  },
  {
    title: "Commercial",
    opportunities: "21 opportunities",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=900&q=85",
  },
  {
    title: "Luxury",
    opportunities: "16 opportunities",
    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=900&q=85",
  },
  {
    title: "Vacation Homes",
    opportunities: "12 opportunities",
    image:
      "https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?auto=format&fit=crop&w=900&q=85",
  },
  {
    title: "Multifamily",
    opportunities: "27 opportunities",
    image:
      "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=900&q=85",
  },
  {
    title: "Development Projects",
    opportunities: "9 opportunities",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=900&q=85",
  },
];
const PropertyGridLoader = () => {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-white/35 p-5 backdrop-blur-xl">
      <div
        className="
          relative
          w-full
          max-w-[390px]
          overflow-hidden
          rounded-[28px]
          border
          border-white
          bg-white/80
          p-7
          text-center
          shadow-[0_30px_90px_rgba(55,92,32,0.16)]
          backdrop-blur-2xl
        "
      >
        <div className="pointer-events-none absolute -left-16 -top-16 h-36 w-36 rounded-full bg-[#e3ecd6]/80 blur-[45px]" />
        <div className="pointer-events-none absolute -bottom-20 -right-16 h-40 w-40 rounded-full bg-[#e8ecd9]/90 blur-[50px]" />

        <div className="relative">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-white bg-[#e3ecd6] text-[#4c7a2e] shadow-[0_10px_28px_rgba(55,92,32,0.10)]">
            <Building2 size={27} strokeWidth={1.7} />
          </div>

          <div className="mx-auto mt-6 h-10 w-10 animate-spin rounded-full border-[3px] border-[#e3ecd6] border-t-[#4c7a2e]" />

          <h3 className="mt-5 font-['Playfair_Display'] text-[22px] font-semibold tracking-[-0.025em] text-[#1f2318]">
            Loading your properties
          </h3>

          <p className="mx-auto mt-2 max-w-[270px] text-[11px] font-medium leading-[1.7] text-[#777967]">
            Preparing your property dashboard. This will only take a moment.
          </p>

          <div className="mt-5 flex items-center justify-center gap-1.5">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#4c7a2e]" />
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#78aabd] [animation-delay:150ms]" />
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#b5d2dc] [animation-delay:300ms]" />
          </div>
        </div>
      </div>
    </div>
  );
};

const publishedProperties = properties.filter( (property) => property?.is_published === true)?.length;
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#fdfbf5] font-['Inter'] text-[#1f2318]">
      {/* SOFT BLURRED PAGE BACKGROUND */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#e3ecd6]/70 blur-[125px]" />
        <div className="absolute -right-44 top-[18%] h-[560px] w-[560px] rounded-full bg-[#e8ecd9]/80 blur-[135px]" />
        <div className="absolute bottom-[-260px] left-[28%] h-[540px] w-[540px] rounded-full bg-[#e5ead7]/60 blur-[130px]" />
        <div className="absolute inset-0 bg-white/15 backdrop-blur-[1px]" />
      </div>
      {/* HEADER */}
      {/* <header className="sticky top-0 z-30 border-b border-white/80 bg-white/70 shadow-[0_8px_30px_rgba(55,92,32,0.06)] backdrop-blur-2xl">
        <div className="mx-auto flex h-[76px] w-full max-w-[1800px] items-center justify-between px-5 sm:px-6 lg:px-10">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-b from-[#6fa142] via-[#4c7a2e] to-[#375c20] shadow-[0_8px_20px_rgba(55,92,32,0.16)]">
              <Building2 size={18} className="text-white" />
            </div>

            <div>
              <div className="font-['Playfair_Display'] text-[20px] font-semibold tracking-[-0.02em] text-[#1f2318]">
                Property Owner
              </div>
             
            </div>
          </div>

          <nav className="hidden items-center gap-1 rounded-full border border-white bg-white/65 p-1 shadow-sm backdrop-blur-xl md:flex">
            <button className="rounded-full bg-[#4c7a2e] px-5 py-2.5 text-[11px] font-bold text-white shadow-[0_6px_16px_rgba(55,92,32,0.15)] transition-all duration-300 hover:-translate-y-0.5">
              My Properties
            </button>

            <button className="rounded-full px-5 py-2.5 text-[11px] font-semibold text-[#777967] transition-all duration-300 hover:bg-white hover:text-[#4c7a2e]">
              Inquiries
            </button>

            <button className="rounded-full px-5 py-2.5 text-[11px] font-semibold text-[#777967] transition-all duration-300 hover:bg-white hover:text-[#4c7a2e]">
              Portfolio
            </button>
          </nav>

          <div className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <div className="text-[11px] font-bold text-[#1f2318]">
                Property Owner
              </div>
              <div className="text-[9px] font-medium text-[#8d8f7e]">
                Owner Account
              </div>
            </div>

            <Dropdown
  menu={userMenu}
  trigger={["click"]}
  placement="bottomRight"
>
  <button
    type="button"
    className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-white bg-[#e3ecd6] text-[11px] font-extrabold text-[#4c7a2e] shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-md"
  >
    {profile?.first_name?.[0]?.toUpperCase() || ""}
{profile?.last_name?.[0]?.toUpperCase() || ""}
  </button>
</Dropdown>
          </div>
        </div>
      </header> */}

<header className="sticky top-0 z-30 border-b border-white/80 bg-white/70 shadow-[0_8px_30px_rgba(55,92,32,0.06)] backdrop-blur-2xl">
  <div className="mx-auto flex h-[76px] w-full max-w-[1800px] items-center justify-between px-5 sm:px-6 lg:px-10">

    {/* ================= LOGO ================= */}
    <div className="flex items-center gap-3">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-b from-[#6fa142] via-[#4c7a2e] to-[#375c20] shadow-[0_8px_20px_rgba(55,92,32,0.16)]">
        <Building2 size={18} className="text-white" />
      </div>

      <div>
        <div className="font-['Playfair_Display'] text-[20px] font-semibold tracking-[-0.02em] text-[#1f2318]">
          Property Owner
        </div>
      </div>
    </div>

    {/* ================= DESKTOP NAVIGATION ================= */}
    <nav className="hidden items-center gap-1 rounded-full border border-white bg-white/65 p-1 shadow-sm backdrop-blur-xl md:flex">

      <button
        type="button"
        className="rounded-full bg-[#4c7a2e] px-5 py-2.5 text-[11px] font-bold text-white shadow-[0_6px_16px_rgba(55,92,32,0.15)] transition-all duration-300 hover:-translate-y-0.5"
      >
        My Properties
      </button>

      <button
        type="button"
        className="rounded-full px-5 py-2.5 text-[11px] font-semibold text-[#777967] transition-all duration-300 hover:bg-white hover:text-[#4c7a2e]"
      >
        Inquiries
      </button>

      <button
        type="button"
        className="rounded-full px-5 py-2.5 text-[11px] font-semibold text-[#777967] transition-all duration-300 hover:bg-white hover:text-[#4c7a2e]"
      >
        Portfolio
      </button>

    </nav>

    {/* ================= RIGHT SIDE ================= */}
    <div className="flex items-center gap-3">

      {/* ================= MOBILE HAMBURGER ================= */}
      <button
        type="button"
        onClick={() => setIsMobileMenuOpen((prev) => !prev)}
        className="
          flex h-10 w-10 items-center justify-center
          rounded-xl
          border border-[#e3ecd6]
          bg-white/80
          text-[#4c7a2e]
          shadow-[0_5px_15px_rgba(55,92,32,0.08)]
          transition-all duration-300
          hover:bg-[#f2f3e9]
          hover:shadow-md
          md:hidden
        "
        aria-label="Toggle navigation menu"
      >
        {isMobileMenuOpen ? (
          <X size={21} strokeWidth={2} />
        ) : (
          <Menu size={21} strokeWidth={2} />
        )}
      </button>

      {/* ================= PROFILE ================= */}
      <div className="flex items-center gap-3">

        <div className="hidden text-right sm:block">
          <div className="text-[11px] font-bold text-[#1f2318]">
            Property Owner
          </div>

          <div className="text-[9px] font-medium text-[#8d8f7e]">
            Owner Account
          </div>
        </div>

        <Dropdown
          menu={userMenu}
          trigger={["click"]}
          placement="bottomRight"
        >
          <button
            type="button"
            className="
              flex h-10 w-10
              cursor-pointer
              items-center justify-center
              rounded-full
              border border-white
              bg-[#e3ecd6]
              text-[11px]
              font-extrabold
              text-[#4c7a2e]
              shadow-sm
              transition-all
              duration-300
              hover:scale-105
              hover:shadow-md
            "
          >
            {profile?.first_name?.[0]?.toUpperCase() || ""}
            {profile?.last_name?.[0]?.toUpperCase() || ""}
          </button>
        </Dropdown>

      </div>
    </div>

  </div>

  {/* ================= MOBILE MENU ================= */}
  {isMobileMenuOpen && (
    <div
      className="
        absolute
        left-0
        right-0
        top-[76px]
        border-t
        border-white/80
        bg-white/90
        px-5
        pb-5
        pt-4
        shadow-[0_15px_35px_rgba(55,92,32,0.12)]
        backdrop-blur-2xl
        md:hidden
      "
    >
      <div
        className="
          overflow-hidden
          rounded-2xl
          border
          border-[#e2e6d8]
          bg-white/75
          p-2
          shadow-[0_10px_30px_rgba(55,92,32,0.08)]
        "
      >

        {/* My Properties */}
        <button
          type="button"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="
            flex w-full items-center
            rounded-xl
            bg-[#4c7a2e]
            px-4 py-3.5
            text-left
            text-[14px]
            font-bold
            text-white
            shadow-[0_6px_16px_rgba(55,92,32,0.15)]
            transition-all
            duration-300
          "
        >
          My Properties
        </button>

        {/* Inquiries */}
        <button
          type="button"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="
            mt-1
            flex w-full items-center
            rounded-xl
            px-4 py-3.5
            text-left
            text-[14px]
            font-semibold
            text-[#777967]
            transition-all
            duration-300
            hover:bg-[#f2f3e9]
            hover:text-[#4c7a2e]
          "
        >
          Inquiries
        </button>

        {/* Portfolio */}
        <button
          type="button"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="
            mt-1
            flex w-full items-center
            rounded-xl
            px-4 py-3.5
            text-left
            text-[14px]
            font-semibold
            text-[#777967]
            transition-all
            duration-300
            hover:bg-[#f2f3e9]
            hover:text-[#4c7a2e]
          "
        >
          Portfolio
        </button>

      </div>
    </div>
  )}
</header>

     <section className="relative mb-12 overflow-hidden rounded-[34px] border border-[#e7e5d8] bg-[#f7f3e8]/80 px-5 py-7 shadow-[0_20px_70px_rgba(55,92,32,0.08)] backdrop-blur-2xl sm:px-8 sm:py-9 lg:px-12 lg:py-12">
        <div className="pointer-events-none absolute -left-28 -top-28 h-72 w-72 rounded-full bg-[#dfe8cf]/80 blur-[90px]" />
        <div className="pointer-events-none absolute -right-24 bottom-[-100px] h-80 w-80 rounded-full bg-[#e8ecd9]/80 blur-[100px]" />

        <div className="relative grid items-center gap-10 lg:grid-cols-[0.92fr_1.08fr] lg:gap-14">
          {/* Hero copy */}
          <div className="max-w-[650px]">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#cfdabd] bg-white/75 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-[#4f5b36] shadow-sm backdrop-blur-md sm:text-[12px]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#6fa142] shadow-[0_0_10px_rgba(111,161,66,0.55)]" />
                Your Property Performance
            </span>

            <h1 className="mt-5 max-w-[650px] text-[38px] font-extrabold leading-[1.04] tracking-[-0.045em] text-[#20231a] sm:text-[48px] lg:text-[58px]">
              
                 Turn your property into opportunity
                  
            </h1>

            <p className="mt-5 max-w-[610px] text-[14px] leading-7 text-[#626454] sm:text-[16px] sm:leading-8">
              It helps property owners showcase and manage their real estate opportunities — from listing your property and sharing its details to reaching potential investors. Add your property, track its progress, and manage everything from one simple dashboard.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#properties"
                className="inline-flex items-center justify-center rounded-full bg-gradient-to-b from-[#6fa142] via-[#4c7a2e] to-[#375c20] px-6 py-3 text-[13px] font-bold text-white shadow-[0_10px_24px_rgba(55,92,32,0.22)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(55,92,32,0.28)]"
              >
              Explore My Properties
                <span className="ml-2 text-[16px]">↗</span>
              </a>

              <a
                href="#properties"
                className="inline-flex items-center justify-center rounded-full border border-[#cfdabd] bg-white/70 px-6 py-3 text-[13px] font-bold text-[#4f5b36] shadow-sm backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:border-[#9fb78a] hover:bg-white"
              >
                View Listings
              </a>
            </div>

            <div className="mt-8 grid max-w-[610px] grid-cols-3 divide-x divide-[#d9ddcd] border-t border-[#dfe2d5] pt-6">
              <div className="pr-3 sm:pr-5">
                <b className="block text-[20px] font-extrabold tracking-[-0.03em] text-[#20231a] sm:text-[24px]">AED 142M+</b>
                <span className="mt-1 block text-[10px] font-medium leading-4 text-[#777967] sm:text-[11px]">Total funded value</span>
              </div>
              <div className="px-3 sm:px-5">
                <b className="block text-[20px] font-extrabold tracking-[-0.03em] text-[#20231a] sm:text-[24px]">2,800+</b>
                <span className="mt-1 block text-[10px] font-medium leading-4 text-[#777967] sm:text-[11px]">Active investors</span>
              </div>
              <div className="pl-3 sm:pl-5">
                <b className="block text-[20px] font-extrabold tracking-[-0.03em] text-[#20231a] sm:text-[24px]">8.4%</b>
                <span className="mt-1 block text-[10px] font-medium leading-4 text-[#777967] sm:text-[11px]">Avg. target yield</span>
              </div>
            </div>
          </div>

          {/* Hero visual */}
          <div className="relative min-h-[360px] sm:min-h-[470px] lg:min-h-[520px]">
            <div className="absolute inset-x-[5%] top-[2%] h-[88%] overflow-hidden rounded-[28px] border border-white/80 bg-white/40 p-2 shadow-[0_24px_55px_rgba(38,63,30,0.14)] backdrop-blur-sm sm:inset-x-[8%] sm:top-0">
              <img
                src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=90"
                alt="Modern investment villa at dusk"
                className="h-full w-full rounded-[21px] object-cover"
              />
              <div className="absolute inset-[8px] rounded-[21px] bg-gradient-to-t from-[#1e2a18]/25 via-transparent to-white/10" />
            </div>

            <div className="absolute bottom-[3%] left-0 hidden h-[150px] w-[42%] overflow-hidden rounded-[22px] border border-white/80 bg-white/60 p-1.5 shadow-[0_18px_40px_rgba(38,63,30,0.16)] backdrop-blur-md sm:block">
              <img
                src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=700&q=80"
                alt="Contemporary property exterior"
                className="h-full w-full rounded-[16px] object-cover"
              />
            </div>

            <div className="absolute left-[3%] top-[10%] rounded-2xl border border-white/70 bg-white/78 px-4 py-3 shadow-[0_14px_35px_rgba(38,63,30,0.15)] backdrop-blur-xl sm:left-0">
              <span className="block text-[10px] font-medium text-[#777967]">Starting investment</span>
              <strong className="mt-0.5 block text-[22px] font-extrabold tracking-[-0.03em] text-[#20231a]">AED 5000</strong>
            </div>

            <div className="absolute right-0 top-[34%] rounded-2xl border border-white/70 bg-white/78 px-4 py-3 shadow-[0_14px_35px_rgba(38,63,30,0.15)] backdrop-blur-xl sm:right-[2%]">
              <span className="block text-[10px] font-medium text-[#777967]">Expected return</span>
              <strong className="mt-0.5 block text-[22px] font-extrabold tracking-[-0.03em] text-[#4c7a2e]">8.5%</strong>
            </div>

            <div className="absolute bottom-[1%] right-[2%] rounded-2xl border border-white/70 bg-[#fdfbf5]/85 px-4 py-3 shadow-[0_14px_35px_rgba(38,63,30,0.15)] backdrop-blur-xl">
              <span className="block text-[10px] font-medium text-[#777967]">Property value</span>
              <strong className="mt-0.5 block text-[22px] font-extrabold tracking-[-0.03em] text-[#20231a]">AED 750K</strong>
            </div>
          </div>
        </div>
      </section>
    

      {/* MAIN */}
      <main className="relative z-10 mx-auto w-full max-w-[1800px] px-5 py-8 sm:px-6 lg:px-10 lg:py-10">
        {/* PAGE HEADING */}
        <div className="mb-2 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.18em] text-[#6a7847] sm:text-[11px]">
              Owner Dashboard
            </p>

            <h1 className="font-['Playfair_Display'] text-[34px] font-semibold leading-[1.08] tracking-[-0.035em] text-[#1f2318] sm:text-[40px]">
              My Properties
            </h1>

            <p className="mt-3 max-w-[650px] text-[12px] font-medium leading-[1.8] text-[#777967] sm:text-[13px]">
              Manage your properties and provide the information investors
              need to evaluate each opportunity.
            </p>
          </div>

          <button
            onClick={openAddModal}
            className="flex h-11 items-center justify-center gap-2 rounded-full bg-[#4c7a2e] px-6 text-[11px] font-bold text-white shadow-[0_10px_25px_rgba(55,92,32,0.16)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#375c20] hover:shadow-[0_14px_30px_rgba(55,92,32,0.20)]"
          >
            <Plus size={15} />
            Add Property
          </button>
        </div>

        {/* SUMMARY */}
        {/* <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <SummaryCard
            label="Total Properties"
            value={properties.length}
            icon={<Building2 size={17} />}
          />

          <SummaryCard
            label="Total Property Value"
            value={formatCurrency(totalValue)}
            icon={<IndianRupee size={17} />}
          />

          <SummaryCard
            label="Listed Properties"
            value={properties.length}
            icon={<HomeIcon size={17} />}
          />
        </div> */}

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">

  <SummaryCard
    label="Total Properties"
    value={properties.length}
    icon={<Building2 size={17} />}
  />

  <SummaryCard
    label="Total Property Value"
    value={formatCurrency(totalValue)}
    icon={<Coins size={17} />}
  />

  <SummaryCard
    label="Published Properties"
    value={publishedProperties}
    icon={<HomeIcon size={17} />}
  />

</div>

        {/* SEARCH */}
        <div className="mt-10 flex flex-col gap-4 rounded-[22px] border border-white/90 bg-white/55 p-5 shadow-[0_12px_35px_rgba(55,92,32,0.06)] backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="font-['Playfair_Display'] text-[23px] font-semibold tracking-[-0.025em] text-[#1f2318]">
              Your Properties
            </h2>
            <p className="mt-1 text-[10px] font-medium text-[#8d8f7e]">
              {properties.length} properties added
            </p>
          </div>

          <div className="relative w-full sm:w-[280px]">
            <Search
              size={14}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-[#999]"
            />

            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search properties..."
              className="h-10 w-full rounded-full border border-white bg-white/80 pl-10 pr-4 text-[11px] font-medium text-[#4f5545] outline-none shadow-sm transition-all duration-300 placeholder:text-[#9aabb2] focus:border-[#b9c99e] focus:bg-white focus:ring-4 focus:ring-[#e3ecd6]/60 sm:w-[300px]"
            />
          </div>
        </div>

        {/* PROPERTY GRID */}
        {isLoading ? (
          <PropertyGridLoader />
        ) : filteredProperties.length > 0 ? (
          <div id="properties" className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
            {filteredProperties.map((property) => (
              <ScrollReveal>
              <PropertyCard
                key={property.id}
                property={property}
                formatCurrency={formatCurrency}
              />
              </ScrollReveal>
            ))}
          </div>
        ) : (
          <EmptyState onAdd={openAddModal} />
        )}


<ScrollReveal>
         <section
          id="property-categories"
          className="
            relative
            mt-20
            overflow-hidden
            px-4
            sm:px-6
            lg:px-8
          "
        >
          {/* ================= MAIN SECTION CARD ================= */}
        
          <div
            className="
              relative
              mx-auto
              w-full max-w-[1800px]
              overflow-hidden
              rounded-[28px]
              border
              border-white/90
              bg-white/45
              px-5
              py-10
              shadow-[0_18px_55px_rgba(55,92,32,0.07)]
              backdrop-blur-xl
              sm:px-8
              sm:py-12
              lg:px-12
              lg:py-14
            "
          >
            {/* ================= SOFT BACKGROUND GLOW ================= */}
        
            <div className="pointer-events-none absolute inset-0 overflow-hidden">
              <div
                className="
                  absolute
                  -left-32
                  -top-32
                  h-[360px]
                  w-[360px]
                  rounded-full
                  bg-[#e3ecd6]/45
                  blur-[100px]
                "
              />
        
              <div
                className="
                  absolute
                  -right-32
                  top-[25%]
                  h-[420px]
                  w-[420px]
                  rounded-full
                  bg-[#e8ecd9]/50
                  blur-[110px]
                "
              />
        
              <div
                className="
                  absolute
                  bottom-[-200px]
                  left-[35%]
                  h-[400px]
                  w-[400px]
                  rounded-full
                  bg-[#e5ead7]/40
                  blur-[110px]
                "
              />
            </div>
        
            {/* ================= CONTENT ================= */}
        
            <div className="relative z-10">
        
              {/* ================= HEADING ================= */}
        
              <div
                className="
                  mb-8
                  grid
                  grid-cols-1
                  items-end
                  gap-5
                  sm:mb-10
                  md:grid-cols-[1fr_0.7fr]
                  lg:mb-11
                "
              >
                <div>
        
                  <p
                    className="
                      mb-3
                      text-[10px]
                      font-bold
                      uppercase
                      tracking-[0.18em]
                      text-[#6a7847]
                      sm:text-[11px]
                    "
                  >
                    Explore real estate
                  </p>
        
                  <h2
                    className="
                      max-w-[650px]
                      text-[30px]
                      font-extrabold
                      leading-[1.12]
                      tracking-[-0.04em]
                      text-[#1f2318]
                      sm:text-[36px]
                      lg:text-[42px]
                    "
                  >
                    Every kind of property,
                    <br />
                    one platform
                  </h2>
        
                  {/* Small accent */}
        
                  <div
                    className="
                      mt-4
                      h-1
                      w-12
                      rounded-full
                      bg-gradient-to-r
                      from-[#4c7a2e]
                      to-[#6fa142]
                    "
                  />
                </div>
        
                <p
                  className="
                    max-w-[390px]
                    pb-1
                    text-[11px]
                    font-medium
                    leading-[1.8]
                    text-[#777967]
                    sm:text-[12px]
                  "
                >
                  Diversify across residential, commercial, and development deals
                  without managing a single one yourself.
                </p>
              </div>
        
              {/* ================= PROPERTY CARDS ================= */}
        
              <div
                className="
                  grid
                  grid-cols-1
                  gap-4
                  sm:grid-cols-2
                  lg:grid-cols-3
                  lg:gap-5
                "
              >
                {propertyCategories.map((property, index) => (
                  <button
                    key={property.title}
                    type="button"
                    className="
                      group
                      relative
                      h-[210px]
                      overflow-hidden
                      rounded-[18px]
                      border
                      border-white/90
                      bg-white
                      text-left
                      shadow-[0_8px_25px_rgba(55,92,32,0.08)]
                      transition-all
                      duration-500
                      ease-[cubic-bezier(.22,1,.36,1)]
                      hover:-translate-y-1
                      hover:shadow-[0_20px_40px_rgba(55,92,32,0.16)]
                      sm:h-[225px]
                    "
                  >
                    {/* ================= IMAGE ================= */}
        
                    <img
                      src={property.image}
                      alt={property.title}
                      className="
                        absolute
                        inset-0
                        h-full
                        w-full
                        object-cover
                        transition-all
                        duration-700
                        ease-[cubic-bezier(.22,1,.36,1)]
                        group-hover:scale-[1.08]
                      "
                    />
        
                    {/* ================= IMAGE OVERLAY ================= */}
        
                    <div
                      className="
                        absolute
                        inset-0
                        bg-gradient-to-t
                        from-[#1f2318]/90
                        via-[#1f2318]/25
                        to-transparent
                        transition-all
                        duration-500
                        group-hover:from-[#1f2318]/95
                        group-hover:via-[#1f2318]/35
                      "
                    />
        
                    {/* ================= HOVER GLOW ================= */}
        
                    <div
                      className="
                        absolute
                        inset-0
                        bg-gradient-to-br
                        from-[#6fa142]/0
                        via-transparent
                        to-[#6fa142]/20
                        opacity-0
                        transition-opacity
                        duration-500
                        group-hover:opacity-100
                      "
                    />
        
                    {/* ================= TOP BADGE ================= */}
        
                    <div
                      className="
                        absolute
                        left-4
                        top-4
                        rounded-full
                        border
                        border-white/20
                        bg-white/10
                        px-2.5
                        py-1
                        text-[8px]
                        font-semibold
                        uppercase
                        tracking-[0.08em]
                        text-white/80
                        opacity-0
                        backdrop-blur-md
                        transition-all
                        duration-500
                        group-hover:translate-y-0
                        group-hover:opacity-100
                      "
                    >
                      Explore
                    </div>
        
                    {/* ================= OPPORTUNITY COUNT ================= */}
        
                    <div
                      className="
                        absolute
                        bottom-[43px]
                        left-4
                      "
                    >
                      <span
                        className="
                          text-[9px]
                          font-medium
                          tracking-[0.02em]
                          text-white/65
                          transition-colors
                          duration-300
                          group-hover:text-white/90
                        "
                      >
                        {property.opportunities}
                      </span>
                    </div>
        
                    {/* ================= TITLE ================= */}
        
                    <div
                      className="
                        absolute
                        bottom-4
                        left-4
                        right-4
                        flex
                        items-center
                        justify-between
                        gap-3
                      "
                    >
                      <h3
                        className="
                          text-[16px]
                          font-bold
                          leading-none
                          tracking-[-0.02em]
                          text-white
                          transition-transform
                          duration-500
                          group-hover:translate-x-1
                          sm:text-[17px]
                        "
                      >
                        {property.title}
                      </h3>
        
                      {/* Arrow */}
        
                      <span
                        className="
                          flex
                          h-8
                          w-8
                          shrink-0
                          translate-x-3
                          items-center
                          justify-center
                          rounded-full
                          border
                          border-white/35
                          bg-white/10
                          text-[14px]
                          text-white
                          opacity-0
                          backdrop-blur-md
                          transition-all
                          duration-500
                          group-hover:translate-x-0
                          group-hover:opacity-100
                        "
                      >
                        ↗
                      </span>
                    </div>
        
                    {/* ================= INNER BORDER ================= */}
        
                    <div
                      className="
                        pointer-events-none
                        absolute
                        inset-0
                        rounded-[18px]
                        border
                        border-transparent
                        transition-all
                        duration-500
                        group-hover:border-white/50
                      "
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        </ScrollReveal>
        {/* <ScrollReveal>
        <PortfolioOverview />
        </ScrollReveal> */}
        <ScrollReveal>
        <footer className="relative mt-20 overflow-hidden px-4 pb-6 sm:px-6 lg:px-8">
          {/* ================= FOOTER CARD ================= */}
        
          <div
            className="
              relative
              mx-auto
              w-full max-w-[1800px]
              overflow-hidden
              rounded-[28px]
              border
              border-white/90
              bg-white/65
              shadow-[0_18px_55px_rgba(55,92,32,0.09)]
              backdrop-blur-xl
            "
          >
            {/* ================= BLURRED BACKGROUND ================= */}
        
            <div className="pointer-events-none absolute inset-0 overflow-hidden">
        
              <div
                className="
                  absolute
                  -left-32
                  -top-32
                  h-[330px]
                  w-[330px]
                  rounded-full
                  bg-[#e3ecd6]/55
                  blur-[100px]
                "
              />
        
              <div
                className="
                  absolute
                  -right-32
                  top-0
                  h-[380px]
                  w-[380px]
                  rounded-full
                  bg-[#e8ecd9]/65
                  blur-[110px]
                "
              />
        
              <div
                className="
                  absolute
                  bottom-[-220px]
                  left-[40%]
                  h-[400px]
                  w-[400px]
                  rounded-full
                  bg-[#e5ead7]/40
                  blur-[110px]
                "
              />
        
              <div className="absolute inset-0 bg-white/20" />
        
            </div>
        
            {/* ================= MAIN FOOTER ================= */}
        
            <div
              className="
                relative
                z-10
                px-6
                py-10
                sm:px-9
                sm:py-12
                lg:px-12
                lg:py-14
              "
            >
        
              <div
                className="
                  grid
                  grid-cols-1
                  gap-10
                  md:grid-cols-[1.35fr_1fr_1fr_1fr_1fr]
                  lg:gap-8
                "
              >
        
                {/* ================= BRAND ================= */}
        
                <div className="max-w-[250px]">
        
                  <div className="flex items-center gap-3">
        
                    <div
                      className="
                        flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-xl
                        bg-[#4c7a2e]
                        text-white
                        shadow-[0_8px_20px_rgba(55,92,32,0.16)]
                      "
                    >
                      <span className="text-[16px]">T</span>
                    </div>
        
                    {/* <span
                      className="
                        text-[18px]
                        font-bold
                        tracking-[-0.03em]
                        text-[#153d54]
                      "
                    >
                      Terra
                    </span> */}
        
                  </div>
        
                  <p
                    className="
                      mt-4
                      text-[11px]
                      font-medium
                      leading-[1.75]
                      text-[#777967]
                    "
                  >
                    Fractional real estate investing, built on
                    transparency and rigorous underwriting.
                  </p>
        
                  <p
                    className="
                      mt-3
                      text-[10px]
                      font-medium
                      leading-[1.6]
                      text-[#8d8f7e]
                    "
                  >
                    Invest smarter. Own more.
                  </p>
        
                </div>
        
                {/* ================= INVESTMENT ================= */}
        
                <div>
        
                  <h3
                    className="
                      text-[10px]
                      font-bold
                      uppercase
                      tracking-[0.12em]
                      text-[#1f2318]
                    "
                  >
                    Investment
                  </h3>
        
                  <div className="mt-4 space-y-2.5">
        
                    <a
                      href="#properties"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Browse properties
                    </a>
        
                    <a
                      href="#how-it-works"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      How investing works
                    </a>
        
                    <a
                      href="#returns"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      View returns
                    </a>
        
                  </div>
        
                </div>
        
                {/* ================= PROPERTIES ================= */}
        
                <div>
        
                  <h3
                    className="
                      text-[10px]
                      font-bold
                      uppercase
                      tracking-[0.12em]
                      text-[#1f2318]
                    "
                  >
                    Properties
                  </h3>
        
                  <div className="mt-4 space-y-2.5">
        
                    <a
                      href="#properties"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      All listings
                    </a>
        
                    <a
                      href="#list-property"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      List a property
                    </a>
        
                    <a
                      href="#property-categories"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Categories
                    </a>
        
                  </div>
        
                </div>
        
                {/* ================= RESOURCES ================= */}
        
                <div>
        
                  <h3
                    className="
                      text-[10px]
                      font-bold
                      uppercase
                      tracking-[0.12em]
                      text-[#1f2318]
                    "
                  >
                    Resources
                  </h3>
        
                  <div className="mt-4 space-y-2.5">
        
                    <a
                      href="#how-it-works"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      How it works
                    </a>
        
                    <a
                      href="#help"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Help center
                    </a>
        
                    <a
                      href="#investor-guide"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Investor guide
                    </a>
        
                  </div>
        
                </div>
        
                {/* ================= COMPANY ================= */}
        
                <div>
        
                  <h3
                    className="
                      text-[10px]
                      font-bold
                      uppercase
                      tracking-[0.12em]
                      text-[#1f2318]
                    "
                  >
                    Company
                  </h3>
        
                  <div className="mt-4 space-y-2.5">
        
                    <a
                      href="#about"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      About
                    </a>
        
                    <a
                      href="#careers"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Careers
                    </a>
        
                    <a
                      href="#contact"
                      className="
                        block
                        text-[11px]
                        font-medium
                        text-[#777967]
                        transition-colors
                        duration-300
                        hover:text-[#4c7a2e]
                      "
                    >
                      Contact
                    </a>
        
                  </div>
        
                </div>
        
              </div>
        
              {/* ================= DIVIDER ================= */}
        
              <div className="my-9 h-px bg-[#dfeaed]" />
        
              {/* ================= BOTTOM ================= */}
        
              <div
                className="
                  flex
                  flex-col
                  gap-5
                  sm:flex-row
                  sm:items-center
                  sm:justify-between
                "
              >
        
                <p
                  className="
                    text-[10px]
                    font-medium
                    text-[#91a1a7]
                  "
                >
                  © 2026 Real Estate, Inc. All rights reserved.
                </p>
        
                <div className="flex items-center gap-5">
        
                  <a
                    href="#privacy"
                    className="
                      text-[10px]
                      font-medium
                      text-[#858676]
                      transition-colors
                      hover:text-[#4c7a2e]
                    "
                  >
                    Privacy
                  </a>
        
                  <span className="text-[#c4d0d4]">•</span>
        
                  <a
                    href="#terms"
                    className="
                      text-[10px]
                      font-medium
                      text-[#858676]
                      transition-colors
                      hover:text-[#4c7a2e]
                    "
                  >
                    Terms
                  </a>
        
                </div>
        
                {/* ================= SOCIAL ================= */}
        
                <div className="flex items-center gap-2">
        
                  <a
                    href="#"
                    aria-label="X"
                    className="
                      flex
                      h-8
                      w-8
                      items-center
                      justify-center
                      rounded-full
                      border
                      border-[#dfe3d5]
                      bg-white/70
                      text-[10px]
                      font-bold
                      text-[#777967]
                      transition-all
                      duration-300
                      hover:-translate-y-0.5
                      hover:border-[#4c7a2e]
                      hover:bg-white
                      hover:text-[#4c7a2e]
                    "
                  >
                    X
                  </a>
        
                  <a
                    href="#"
                    aria-label="LinkedIn"
                    className="
                      flex
                      h-8
                      w-8
                      items-center
                      justify-center
                      rounded-full
                      border
                      border-[#dfe3d5]
                      bg-white/70
                      text-[10px]
                      font-bold
                      text-[#777967]
                      transition-all
                      duration-300
                      hover:-translate-y-0.5
                      hover:border-[#4c7a2e]
                      hover:bg-white
                      hover:text-[#4c7a2e]
                    "
                  >
                    in
                  </a>
        
                  <a
                    href="#"
                    aria-label="Instagram"
                    className="
                      flex
                      h-8
                      w-8
                      items-center
                      justify-center
                      rounded-full
                      border
                      border-[#dfe3d5]
                      bg-white/70
                      text-[10px]
                      font-bold
                      text-[#777967]
                      transition-all
                      duration-300
                      hover:-translate-y-0.5
                      hover:border-[#4c7a2e]
                      hover:bg-white
                      hover:text-[#4c7a2e]
                    "
                  >
                    ◎
                  </a>
        
                </div>
        
              </div>
        
            </div>
          </div>
        </footer>
        </ScrollReveal>
        
      </main>

      {/* ADD / EDIT MODAL */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1f2318]/25 p-4 backdrop-blur-md">
          <div className="max-h-[92vh] w-full max-w-[850px] overflow-hidden rounded-[26px] border border-white/90 bg-white/90 shadow-[0_30px_90px_rgba(55,92,32,0.20)] backdrop-blur-2xl">
            {/* MODAL HEADER */}
            <div className="flex items-center justify-between border-b border-[#e4e7db] bg-white/75 px-6 py-5">
              <div>
                <h2 className="font-['Playfair_Display'] text-[23px] font-semibold tracking-[-0.025em] text-[#1f2318]">
                  Add New Property
                </h2>

                <p className="mt-1 text-[11px] font-medium text-[#777967]">
                  Add the property information required for submission.
                </p>
              </div>

              <button
                onClick={closeModal}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-[#e1e4d8] bg-white text-[#6f705f] shadow-sm transition-all duration-300 hover:bg-[#edf6f8] hover:text-[#4c7a2e]"
              >
                <X size={15} />
              </button>
            </div>

            {/* FORM */}
            <form
              onSubmit={handleSubmit}
              className="max-h-[calc(92vh-82px)] overflow-y-auto"
            >
              <div className="space-y-8 bg-[#faf8f0]/70 p-6 sm:p-7">
                {/* BASIC INFORMATION */}
                <FormSection
                  number="01"
                  title="Basic Information"
                  description="Tell investors about the property."
                >
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <InputField
                      label="Property Name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="e.g. Premium Marina Apartment"
                      required
                    />

                    <SelectField
                      label="Property Type"
                      name="property_type"
                      value={form.property_type}
                      onChange={handleChange}
                      options={[
                        "Apartment",
                        // "Flat",
                        "Villa",
                        "Townhouse",
                        "Land",
                        "Penthouse"
                        // "Commercial",
                        // "Retail",
                        // "Warehouse",
                      ]}
                    />

                    <InputField
                      label="Location"
                      name="location"
                      value={form.location}
                      onChange={handleChange}
                      placeholder="e.g. Dubai Marina"
                      required
                    />
                    <InputField
                      label="Area"
                      name="zone_name"
                      value={form.zone_name}
                      onChange={handleChange}
                      placeholder="Area"
                      required
                    />

                    <div className="md:col-span-2">
                      <label className="mb-2 block text-[10px] font-bold uppercase tracking-[0.04em] text-[#526d79]">
                        Description
                      </label>

                      <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        rows={3}
                        placeholder="Describe the property, location, amenities and investment potential..."
                        className="w-full resize-none rounded-xl border border-[#dbe8ec] bg-white/80 px-3.5 py-3 text-[12px] font-medium text-[#4f5545] outline-none transition-all duration-300 placeholder:text-[#a2b1b7] focus:border-[#8ebdcd] focus:bg-white focus:ring-4 focus:ring-[#e3ecd6]/60"
                      />
                    </div>
                  </div>
                </FormSection>

                {/* PROPERTY DETAILS */}
                <FormSection
                  number="02"
                  title="Property Details"
                  description="Add the investment structure for this property."
                >
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
                    
                    <InputField
                       label="Property Area (sqft)"
                       name="area_sqft"
                       value={form.area_sqft}
                       onChange={handleChange}
                       placeholder="e.g. 1,420 "
                       type="number"
                       min="0"
                       required
                     />

                    <InputField
                      label="Rental Agency "
                      name="registered_agency"
                      value={form.registered_agency }
                      onChange={handleChange}
                      placeholder="Rental Agency"
                      required
                    />
                    <InputField
                      label="Rera Number"
                      name="rera_number"
                      value={form.rera_number}
                      onChange={handleChange}
                      placeholder="rera number"
                      required
                    />
                    <InputField
                      label="BRN"
                      name="brn"
                      value={form.brn}
                      onChange={handleChange}
                      placeholder="BRN"
                      required
                    />

                    <InputField
                      label="Gross Annual Yield (%)"
                      name="gross_annual_yield_pct"
                      type="number"
                      min="0"
                      step="0.01"
                      value={form.gross_annual_yield_pct}
                      onChange={handleChange}
                      placeholder="10.8"
                    />
                  </div>
                </FormSection>

                {/* FINANCIAL INFORMATION */}
                <FormSection
                  number="03"
                  title="Property Value"
                  description="Enter the total value of the property in AED."
                >
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    
                    <InputField
                      label="Property Value (AED)"
                      name="property_value_aed"
                      type="number"
                      min="0"
                      value={form.property_value_aed}
                      onChange={handleChange}
                      placeholder="4800000"
                      required
                    />
                    <InputField
                      label="how much tokens you want to mint"
                      name="total_tokens"
                      type="number"
                      min="1"
                      value={form.total_tokens}
                      onChange={handleChange}
                      placeholder="1000"
                      required
                    />
                    <InputField
                      label="Vesting Period (days)"
                      name="vesting_days"
                      type="number"
                      min="0"
                      value={form.vesting_days}
                      onChange={handleChange}
                      placeholder="0"
                      required
                    />
                    <p className="-mt-2 text-[10px] text-[#8a9295] md:col-span-2">
                      Days newly-purchased tokens must wait before investors
                      can resell or transfer them. Leave as 0 for no lock-up
                      period.
                    </p>
                  </div>
                </FormSection>

                {/* IMAGE */}
                <FormSection
  number="04"
  title="Property Images"
  description="Add multiple images to showcase your property. The first image will be used as the cover image."
>
  <div className="space-y-4">

    {/* UPLOAD AREA */}
    <label
      htmlFor="property-images"
      className="group flex cursor-pointer flex-col items-center justify-center rounded-[18px] border border-dashed border-[#cbdfe6] bg-white/70 px-5 py-8 transition-all duration-300 hover:border-[#76aabd] hover:bg-white hover:shadow-[0_10px_28px_rgba(55,92,32,0.06)]"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#e7f3f7] text-[#4c7a2e] transition-all duration-300 group-hover:-translate-y-1 group-hover:bg-[#dceef5]">
        <Upload size={18} />
      </div>

      <p className="mt-3 text-[13px] font-bold text-[#4f5545]">
        Upload property images
      </p>

      <p className="mt-1.5 text-[10px] font-medium text-[#8d8f7e]">
        Select multiple JPG, PNG or WEBP images
      </p>

      <span className="mt-4 rounded-full bg-[#4c7a2e] px-5 py-2.5 text-[10px] font-bold text-white shadow-sm">
        Choose Files
      </span>

      <input
        id="property-images"
        type="file"
        accept="image/png,image/jpeg,image/webp"
        multiple
        className="hidden"
        onChange={handleImageUpload}
      />
    </label>

    {/* URL INPUT */}
    {/* <div>
      <div className="mb-2 flex items-center gap-2">
        <div className="h-px flex-1 bg-[#eeeeeb]" />

        <span className="text-[9px] uppercase tracking-[0.12em] text-[#aaa]">
          or add image URL
        </span>

        <div className="h-px flex-1 bg-[#eeeeeb]" />
      </div>

      <div className="flex gap-2">
        <input
          type="text"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
          placeholder="https://example.com/property-image.jpg"
          className="h-9 flex-1 rounded-[6px] border border-[#deded9] bg-white px-3 text-[10px] outline-none focus:border-[#375c20]"
        />

        <button
          type="button"
          onClick={handleAddImageUrl}
          className="h-9 rounded-[6px] bg-[#375c20] px-4 text-[10px] font-semibold text-white transition hover:bg-[#173d4f]"
        >
          Add
        </button>
      </div>
    </div> */}

    {/* IMAGE PREVIEW */}
    {form.images?.length > 0 && (
      <div>
        <div className="mb-2 flex items-center justify-between">
          <div>
            <p className="text-[10px] font-semibold text-[#555]">
              Property Images
            </p>

            <p className="mt-0.5 text-[9px] text-[#999]">
              {form?.images.length} image
              {form?.images.length !== 1 ? "s" : ""} added
            </p>
          </div>

          <span className="text-[9px] text-[#999]">
            First image is the cover
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3">
          {form?.images.map((image, index) => (
            <ImagePreview
              key={image.id}
              image={image}
              index={index}
              onRemove={handleRemoveImage}
            />
          ))}
        </div>
      </div>
    )}

  </div>
</FormSection>
              </div>

              {/* MODAL FOOTER */}
              <div className="sticky bottom-0 flex items-center justify-end gap-3 border-t border-[#e4e7db] bg-white/90 px-6 py-4 backdrop-blur-xl">
                <button
                  type="button"
                  onClick={closeModal}
                  className="h-10 rounded-full border border-[#d9e7eb] bg-white px-6 text-[10px] font-bold text-[#647b85] transition-all duration-300 hover:bg-[#f5fafb]"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="h-10 rounded-full bg-[#4c7a2e] px-7 text-[10px] font-bold text-white shadow-[0_10px_22px_rgba(55,92,32,0.16)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#375c20] disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {isSubmitting ? "Adding Property..." : "Add Property"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ProfileModal
        isOpen={isProfileModalOpen}
        onClose={() => {
          setIsProfileModalOpen(false);
          // setProfile(null);
        }}
        profile={profile}
        isLoading={isProfileLoading}
      />
    </div>
  );
};


const ProfileItem = ({ label, value }) => {
  return (
    <div className="rounded-[15px] border border-[#e2edf1] bg-white/75 p-4 shadow-sm">
      <p className="text-[9px] font-bold uppercase tracking-[0.08em] text-[#8d8f7e]">
        {label}
      </p>

      <p className="mt-1.5 break-all text-[11px] font-bold text-[#4f5545]">
        {value !== null &&
        value !== undefined &&
        value !== ""
          ? String(value)
          : "-"}
      </p>
    </div>
  );
};


const PropertyCard = ({
  property,
  formatCurrency,
}) => {
  const totalBlocks = Number(property?.total_tokens || 0);
  const blocksSold = Number(property?.blocks_sold || 0);
  const navigate = useNavigate()

  const availableBlocks = Math.max(
    totalBlocks - blocksSold,
    0
  );

  const fundingPercentage = Math.min(
    Math.max(Number(property?.funding_pct || 0), 0),
    100
  );
  const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // Already a complete URL
  if (
    imagePath.startsWith("http://") ||
    imagePath.startsWith("https://")
  ) {
    return imagePath;
  }

  // If API returns a relative path
  console.log(`${BASE_URL}/"uploads"/${imagePath})`);
  return `${BASE_URL}/uploads/${imagePath.replace(/^\/+/, "")}`;
};



  const imagePath = property?.image_paths?.[0];
  const imageUrl = getImageUrl(imagePath);

  const status =
    property?.submission_status || "Pending";

  const getStatusStyle = () => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "published":
        return "bg-[#e1f6e9] text-[#16894a]";

      case "rejected":
        return "bg-[#fbe4e2] text-[#b84e46]";

      case "pending":
      case "pending_review":
      default:
        return "bg-[#fff3d5] text-[#b27a16]";
    }
  };
  const handleViewInvestment = (property) => {
  console.log("PROPERTY:", property);
  console.log("PROPERTY ID:", property?.id);

  if (!property?.id) {
    console.log("Property ID is missing");
    return;
  }

  navigate(`/agent/property/view/${property.id}`, {
    state: {
      id: property.id,
    },
  });
};

  return (
    <div className="group overflow-hidden rounded-[22px] border border-white/90 bg-white/80 shadow-[0_14px_38px_rgba(55,92,32,0.08)] backdrop-blur-xl transition-all duration-500 hover:-translate-y-1.5 hover:border-white hover:bg-white hover:shadow-[0_24px_55px_rgba(55,92,32,0.13)]">

      <div className="relative h-[205px] overflow-hidden bg-[#eaf3f6] cursor-pointer" onClick={()=>handleViewInvestment(property)}>

        {imageUrl ? (
          <img
            src={imageUrl}
            alt={property?.name || "Property"}
            className="h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : (
          <div className="flex h-full flex-col items-center justify-center text-[#8d8f7e]">
            <Building2 size={30} strokeWidth={1.3} />

            <span className="mt-2 text-[10px] font-medium">
              No image available
            </span>
          </div>
        )}

        {/* PROPERTY TYPE */}
        <div className="absolute left-3 top-3 rounded-full border border-white/80 bg-white/90 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.06em] text-[#4c7a2e] shadow-sm backdrop-blur-md">
          {property?.property_type || "Property"}
        </div>

        {/* STATUS */}
        <div
          className={`absolute right-3 top-3 rounded-full px-3 py-1.5 text-[9px] font-bold shadow-sm backdrop-blur-md ${getStatusStyle()}`}
        >
          {status}
        </div>
      </div>

      {/* CONTENT */}
      <div className="bg-[#faf8f0]/70 p-6">

        {/* LOCATION + TITLE */}
        <div>
          <div className="flex items-center gap-1.5 text-[10px] font-medium text-[#8297a0]">
            <MapPin size={10} />

            <span className="truncate">
              {property?.location || "Location not available"}
            </span>
          </div>

          <h3 className="mt-1.5 font-['Playfair_Display'] text-[20px] font-semibold leading-6 tracking-[-0.02em] text-[#1f2318]">
            {property?.name || "Untitled Property"}
          </h3>
        </div>

        {/* DESCRIPTION */}
        <p className="mt-2.5 line-clamp-2 text-[11px] font-medium leading-[1.65] text-[#777967]">
          {property?.description ||
            "No description added for this property."}
        </p>

        {/* VALUE */}
        <div className="mt-5 grid grid-cols-2 rounded-[15px] border border-[#e4e7db] bg-[#faf8f0]/80 py-3.5 px-4">

          <div>
            <p className="text-[9px] font-semibold uppercase tracking-[0.06em] text-[#8d8f7e]">
              Property Value
            </p>

            <p className="mt-1 text-[14px] font-extrabold tracking-[-0.02em] text-[#1f2318]">
              {formatCurrency(
                property?.property_value_aed
              )}
            </p>
          </div>

          <div className="border-l border-[#e1e4d8] pl-4">
            <p className="text-[9px] font-semibold uppercase tracking-[0.06em] text-[#8d8f7e]">
              Price / Token
            </p>

            <p className="mt-1 text-[14px] font-extrabold tracking-[-0.02em] text-[#1f2318]">
              {formatCurrency(
                property?.price_per_block_aed
              )}
            </p>
          </div>

        </div>

        {/* BLOCK INFO */}
        <div className="mt-4">

          <div className="flex justify-between text-[10px]">
            <span className="font-medium text-[#8297a0]">
              Funding Progress
            </span>

            <span className="font-bold text-[#4c7a2e]">
              {Math.round(fundingPercentage)}%
            </span>
          </div>

          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-[#e5eef1]">
            <div
              className="h-full rounded-full bg-gradient-to-r from-[#4c7a2e] to-[#6fa142] transition-all duration-700"
              style={{
                width: `${fundingPercentage}%`,
              }}
            />
          </div>

          <div className="mt-1.5 flex justify-between text-[9px] font-medium text-[#8d8f7e]">
            <span>
              {blocksSold.toLocaleString()} tokens sold
            </span>

            <span>
              {availableBlocks.toLocaleString()} available
            </span>
          </div>

        </div>

        {/* ROI */}
        <div className="mt-4 flex items-center justify-between rounded-xl border border-[#e4e7db] bg-[#f5fafb] px-3.5 py-2.5">

          <span className="text-[10px] font-medium text-[#777967]">
            Gross Annual Yield
          </span>

          <span className="text-[12px] font-bold text-[#16894a]">
            {Number(
              property?.gross_annual_yield_pct || 0
            ).toFixed(1)}
            %
          </span>

        </div>

                <div className="mt-5 flex items-center gap-2">
            <button
              // onClick={() => onEdit(property)}
              className="flex h-9 flex-1 items-center justify-center gap-1.5 rounded-full border border-[#d7e5ea] bg-white text-[10px] font-bold text-[#617984] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#b9d3dd] hover:bg-[#f7fbfc] hover:text-[#4c7a2e]"
            >
              <Pencil size={11} />
              Edit
            </button>
            <Tooltip title="View" >

            <button
                onClick={()=>handleViewInvestment(property)}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-[#d7e5ea] bg-white text-[#617984] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#b9d3dd] hover:bg-[#f7fbfc] hover:text-[#4c7a2e]"
              >
              <Eye size={16}/>
            </button>
            </Tooltip>

            <button
              // onClick={() => onRemove(property.id)}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-[#efdcd9] bg-white text-[#a15a50] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#fff7f5]"
            >
              <Trash2 size={12} />
            </button>
          </div>

            
      </div>
    </div>
  );
};

const ProfileModal = ({
  isOpen,
  onClose,
  profile,
  isLoading,
}) => {
  if (!isOpen) return null;

  const firstName =
    profile?.first_name ||
    profile?.firstname ||
    profile?.firstName ||
    "";

  const lastName =
    profile?.last_name ||
    profile?.lastname ||
    profile?.lastName ||
    "";

  const fullName =
    profile?.name ||
    profile?.full_name ||
    profile?.fullName ||
    `${firstName} ${lastName}`.trim();

  const email =
    profile?.email ||
    profile?.email_address ||
    "";

  const phone =
    profile?.phone ||
    profile?.phone_number ||
    profile?.mobile ||
    "";

  const walletAddress =
    profile?.wallet_address ||
    profile?.walletAddress ||
    "";

  const role =
    profile?.role ||
    profile?.user_role ||
    "Investor";

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#1f2318]/25 px-4 backdrop-blur-md"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[520px] overflow-hidden rounded-[26px] border border-white/90 bg-white/90 shadow-[0_30px_90px_rgba(55,92,32,0.20)] backdrop-blur-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-[#e4e7db] bg-white/75 px-6 py-5">
          <div>
            <h2 className="font-['Playfair_Display'] text-[22px] font-semibold tracking-[-0.02em] text-[#1f2318]">
              My Profile
            </h2>

            <p className="mt-1 text-[10px] font-medium text-[#777967]">
              Your account information
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#e1e4d8] bg-white text-[#6f705f] shadow-sm transition-all duration-300 hover:bg-[#edf6f8] hover:text-[#4c7a2e]"
          >
            <X size={15} />
          </button>
        </div>

        {/* Body */}
        <div className="bg-[#faf8f0]/70 p-6">
          {isLoading ? (
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 animate-pulse rounded-full bg-gray-200" />

                <div className="flex-1 space-y-2">
                  <div className="h-3 w-32 animate-pulse rounded bg-gray-200" />
                  <div className="h-2 w-20 animate-pulse rounded bg-gray-200" />
                </div>
              </div>

              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div className="h-[60px] animate-pulse rounded-lg bg-gray-200" />
                <div className="h-[60px] animate-pulse rounded-lg bg-gray-200" />
                <div className="h-[60px] animate-pulse rounded-lg bg-gray-200" />
                <div className="h-[60px] animate-pulse rounded-lg bg-gray-200" />
              </div>
            </div>
          ) : profile ? (
            <>
              {/* Profile Header */}
              <div className="mb-6 flex items-center gap-4 rounded-[18px] border border-[#e4e7db] bg-white/70 p-4 shadow-sm">
                <div className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-2xl bg-[#e3ecd6] text-[15px] font-extrabold text-[#4c7a2e]">
                  {(
                    `${firstName?.[0] || ""}${lastName?.[0] || ""}` ||
                    fullName?.[0] ||
                    "I"
                  ).toUpperCase()}
                </div>

                <div className="min-w-0">
                  <p className="truncate text-[15px] font-bold tracking-[-0.02em] text-[#1f2318]">
                    {fullName || "Investor"}
                  </p>

                  <p className="mt-1 text-[10px] font-medium text-[#8297a0]">
                    {role}
                  </p>
                </div>
              </div>

              {/* Details */}
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <ProfileItem
                  label="First Name"
                  value={firstName}
                />

                <ProfileItem
                  label="Last Name"
                  value={lastName}
                />

                <ProfileItem
                  label="Email"
                  value={email}
                />

                <ProfileItem
                  label="Phone"
                  value={phone}
                />


              </div>
            </>
          ) : (
            <div className="py-8 text-center">
              <User
                size={30}
                className="mx-auto text-[#375c20]"
              />

              <p className="mt-3 text-[11px] font-medium text-[#526067]">
                Unable to load profile information.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SummaryCard = ({ label, value, icon }) => {
  return (
    <div className="group flex items-center justify-between rounded-[20px] border border-white/90 bg-white/75 px-5 py-5 shadow-[0_12px_35px_rgba(55,92,32,0.07)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_42px_rgba(55,92,32,0.10)]">
      <div>
        <p className="text-[9px] font-bold uppercase tracking-[0.12em] text-[#8297a0]">
          {label}
        </p>

        <p className="mt-1.5 text-[25px] font-extrabold tracking-[-0.035em] text-[#1f2318]">
          {value}
        </p>
      </div>

      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#e3ecd6] text-[#4c7a2e] transition-transform duration-300 group-hover:scale-105">
        {icon}
      </div>
    </div>
  );
};


const FormSection = ({ number, title, description, children }) => {
  return (
    <section>
      <div className="mb-5 flex gap-3">
        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#e3ecd6] font-['Inter'] text-[9px] font-extrabold text-[#4c7a2e]">
          {number}
        </div>

        <div>
          <h3 className="text-[15px] font-bold tracking-[-0.015em] text-[#1f2318]">
            {title}
          </h3>

          <p className="mt-1 text-[10px] font-medium leading-[1.6] text-[#8297a0]">{description}</p>
        </div>
      </div>

      {children}
    </section>
  );
};

const InputField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  required = false,
}) => {
  return (
    <div>
      <label className="mb-2 block text-[10px] font-bold uppercase tracking-[0.04em] text-[#526d79]">
        {label}
        {required && <span className="ml-1 text-[#a27a28]">*</span>}
      </label>

      <input
        name={name}
        type={type}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="h-11 w-full rounded-xl border border-[#dbe8ec] bg-white/80 px-3.5 text-[12px] font-medium text-[#4f5545] outline-none transition-all duration-300 placeholder:text-[#a2b1b7] focus:border-[#8ebdcd] focus:bg-white focus:ring-4 focus:ring-[#e3ecd6]/60"
      />
    </div>
  );
};


const SelectField = ({
  label,
  name,
  value,
  onChange,
  options,
}) => {
  return (
    <div>
      <label className="mb-2 block text-[10px] font-bold uppercase tracking-[0.04em] text-[#526d79]">
        {label}
      </label>

      <div className="relative">
        <select
          name={name}
          value={value}
          onChange={onChange}
          className="h-11 w-full appearance-none rounded-xl border border-[#dbe8ec] bg-white/80 px-3.5 pr-9 text-[12px] font-medium text-[#4f5545] outline-none transition-all duration-300 focus:border-[#8ebdcd] focus:bg-white focus:ring-4 focus:ring-[#e3ecd6]/60"
        >
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <ChevronDown
          size={13}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#888]"
        />
      </div>
    </div>
  );
};

const EmptyState = ({ onAdd, hasSearch }) => {
  return (
    <div className="mt-8 flex min-h-[350px] flex-col items-center justify-center rounded-[24px] border border-dashed border-[#cddfe6] bg-white/65 px-6 text-center shadow-[0_12px_35px_rgba(55,92,32,0.05)] backdrop-blur-xl">

      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#e3ecd6] text-[#4c7a2e] shadow-sm">
        <Building2 size={21} />
      </div>

      <h3 className="mt-5 font-['Playfair_Display'] text-[23px] font-semibold tracking-[-0.025em] text-[#1f2318]">
        {hasSearch
          ? "No properties found"
          : "No properties yet"}
      </h3>

      <p className="mt-2 max-w-[380px] text-[11px] font-medium leading-[1.7] text-[#8297a0]">
        {hasSearch
          ? "Try adjusting your search to find the property you're looking for."
          : "Add your first property to make it available for fractional investment."}
      </p>

      {!hasSearch && (
        <button
          onClick={onAdd}
          className="mt-6 flex h-10 items-center gap-2 rounded-full bg-[#4c7a2e] px-6 text-[10px] font-bold text-white shadow-[0_10px_22px_rgba(55,92,32,0.16)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#375c20]"
        >
          <Plus size={13} />
          Add Your First Property
        </button>
      )}

    </div>
  );
};

export default OwnerHome;